import React, { Component } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { TextField } from '@material-ui/core';

class GoogleLocation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            address: '',
            errorMessage: '',
        };
    }

    handleError = (status, clearSuggestions) => {
        this.setState({ errorMessage: status }, () => {
          clearSuggestions();
        });
    };

    textChange = address => this.props.onChange(address);
     
    handleSelect = address => this.props.onSelect(address);

    render() {
        const { defaultValue } = this.props;
        return (<>
            <PlacesAutocomplete
                value={defaultValue}
                onChange={this.textChange}
                onSelect={this.handleSelect}
                onError={this.handleError}
                //searchOptions={{componentRestrictions: {'country': ['bm']}}}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className="google-location">
                    <input
                    {...getInputProps({
                        type: 'text',
                        className: 'location-search-input form-control',
                        placeholder: 'Enter Address'
                    })} />
                    <div className="autocomplete-dropdown">
                        <div className="box-inner">
                            {loading && <div className="spinner"><div className="spinner-border text-primary" role="status"></div></div>}
                            {suggestions.map(suggestion => {
                                const className = suggestion.active ? 'suggestion active' : 'suggestion';
                                return (
                                <div
                                    {...getSuggestionItemProps(suggestion, {
                                    className,
                                    })}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                )}
            </PlacesAutocomplete>
            {this.state.errorMessage.length > 0 && (
                <div className="Demo__error-message text-danger">{this.state.errorMessage}</div>
            )}
        </>);
    }
}

export default GoogleLocation;